import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '../baseQuery/createBaseQuery';

export const localhostApiV2 = createApi({
  reducerPath: 'localhostApi',
  baseQuery: createBaseQuery({
    version: 'v2',
    overrideBaseUrl: `http://localhost:${
      import.meta.env.VITE_BACKEND_LOCAL_TESTING_PORT || '8080'
    }`,
  }),
  endpoints: () => ({}), // inject endpoints at the feature level
});
